<template>
  <span class="breadcrumb_item">
    <span style="cursor:pointer" class="breadcrumb_item_inner" ref="link"><slot></slot></span>
    <span style="cursor:pointer" class="breadcrumb_item_separator"> {{ separator }}</span>
  </span>
</template>

<script>
export default {
  name: 'breadcrumbItem',
  props: {
    to: {},
    replace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      separator: ''
    }
  },
  mounted () {
    this.separator = this.$parent.separator
    let _this = this
    if (_this.to) {
      let link = _this.$refs.link
      link.addEventLisenter('click', () => {
        let to = _this.to
        _this.replace ? _this.$router.replace(to) : _this.$router.push(to)
      })
    }
  }
}
</script>

<style scoped>
  .breadcrumb_item:last-child {
    color: #000000;
  }
  .breadcrumb_item:last-child .breadcrumb_item_separator {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/commonBreadcrumb/breadcrumbItem.vue